export const forms = {
    addNewsForm: 'addNewsForm',
    updateNewsForm: 'updateNewsForm',
};

export const newsFields = {
    title: 'title',
    body: 'body',
    tags: 'tags',
};

export const requiredFields = [newsFields.title];
export const localizableFields = [newsFields.title, newsFields.body];

export const defaultValues = {
    tags: [],
    images: [],
};
